export const SITE_URL = "https://jerrytherapy.com";
export const SITE_NAME = "Jerry's Therapy";
export const OG_IMAGE =
  "https://storage.googleapis.com/gpt-engineer-file-uploads/H11f8sPnVxbVMPidooAs9ItoKYe2/social-images/social-1779981374622-471545535_939535584984826_3569874149568045930_n.webp";

export function absoluteUrl(path = "/") {
  return new URL(path, SITE_URL).toString();
}
